import { Mode } from "@/modes/mode";
import { selectIpxOrderHasProgress } from "@/store/modes/ipx-order-mode-selectors";
import {
  cancelIpxOrderWizard,
  completeIpxOrderWizard,
} from "@/store/modes/ipx-order-mode-thunks";
import { IpxOrderModeOverlay } from "./ipx-order-mode-overlay";
import { IpxOrderModeScene } from "./ipx-order-mode-scene";
import { IPX_ORDER_STEPS } from "./ipx-order-steps";

/** Prototype of the IPX Scan-to-BIM ordering workflow (PDI-538), the first mode using the wizard layout */
export const ipxOrderMode: Mode = {
  name: "ipxOrder",
  ModeScene: IpxOrderModeScene,
  ModeOverlay: IpxOrderModeOverlay,
  wizard: {
    title: "Get floor plans and BIM models",
    steps: IPX_ORDER_STEPS,
    selectHasProgress: selectIpxOrderHasProgress,
    onExit({ dispatch }, activeStepKey) {
      dispatch(cancelIpxOrderWizard(activeStepKey));
      return Promise.resolve();
    },
    onComplete({ dispatch }) {
      dispatch(completeIpxOrderWizard());
      return Promise.resolve();
    },
  },
};
